// extracted by mini-css-extract-plugin
module.exports = {"row":"detail_row__1LKc5","label":"detail_label__xKVK1","photoDetail":"detail_photoDetail__8ffEa","photos":"detail_photos__2qyjV","photo":"detail_photo__3L2OB"};